<!-- <div class="my-container mr-5"> -->
  <!-- <button (click)="getSysTables()">get system tables</button> -->

  <!--radio-->
  <!-- <input type="radio" class="app-input" name="item" id="item-1" checked>
  <label for="item-1">כן</label>


  <input type="radio" class="app-input" name="item" id="item-2">
  <label for="item-2">לא</label> -->

  <!--checkbox-->
  <!-- <input type="checkbox" class="app-input" name="checkbox-1" id="checkbox-1" checked>
  <label for="checkbox-1" class="check">כן</label>


  <input type="checkbox" class="app-input" name="checkbox-2" id="checkbox-2">
  <label for="checkbox-2" class="check">
    Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptatibus doloribus mollitia repellat corrupti deleniti
    rem a perspiciatis, molestias voluptate molestiae consequuntur quibusdam,
    nostrum aut dignissimos voluptatem quidem laudantium quis architecto nobis. Cum unde soluta nisi tempore neque ea,
    illum quibusdam! Reiciendis soluta culpa doloremque eaque, exercitationem explicabo reprehenderit excepturi
    iste.
  </label>


  <div class="mb-5 mt-5"> -->
    <!--text field-->
    <!-- <div class="input-wrapper">
      <input type="text" class="app-input" required />
      <label class="label">שם מלא</label>
      <label class="error-label">אנא הקלד שם מלא</label>
    </div> -->
  <!-- </div> -->

  <!-- <div class="mb-5 mt-5"> -->
    <!--text field- new -->
    <!-- <div class="input-wrapper1">
      <input type="text" class="app-input1" required />
      <label class="label1">שם מלא</label>
      <label class="error-label">אנא הקלד שם מלא</label>
    </div> -->
  <!-- </div> -->

  <!--buttons-->
  <!-- <div class="mb-5">
    <button class="app-button button-primary">הגשת בקשה חדשה למשכנתא</button>
  </div>

  <div class="mb-5">
    <button class="app-button button-secondery">המשך תהליך בקשה</button>
  </div>

  <div class="mb-5">
    <button class="app-button button-primary-disabled">הגשת בקשה חדשה למשכנתא</button>
  </div>

  <div class="mb-5">
    <button class="app-button button-secondary-disabled">המשך תהליך בקשה</button>
  </div> -->

  <!--date-picker-->
  <!-- <form [formGroup]="userDetails"> -->

    <!-- <div class="d-flex justify-content-center">
      <div class="form-group">
        <div class="input-group m-datepicker" style="direction:ltr">
          <input class="app-input form-control m-form-control" autocomplete="on" [minDate]="minBirthDate"
            [maxDate]="maxBirthDate" [firstDayOfWeek]=7 formControlName="birthDate" placeholder="dd/mm/yyyy" name="d2"
            ngbDatepicker #d2="ngbDatepicker" [attr.aria-label]="'BORROWERS_DETAILS.QUESTION1.BIRTH_DAY'|translate">
          <div class="input-group-append">
            <button (click)="d2.toggle()" type="button">
              <i class="fa fa-calendar fa-lg" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </div> -->



  <!--tooltip-->
  <!-- <div class="mb-5">
    <inner-tooltip [qTitle]="'START.LINK_TOOLTIP'|translate" [text]="'START.TOOLTIP_TEXT'|translate"
      class="m-start-tooltip app-title-small-white">
    </inner-tooltip>
  </div> -->

  <!--textarea-->
  <!-- <div class="mb-5">
    <h2 class="app-title-midi text-right">{{'SUMMARIZE.MSG_5' | translate}}</h2>
    <textarea placeholder="{{'SUMMARIZE.PLACE_HOLDER' | translate}}"></textarea>
  </div> -->

  <!--select dropdown-->
  <!-- <div class="container my-select-box">
    <app-dplist [collection]="maritalStatus" [formControl]="formGroup.controls['maritalStatus']" ngDefaultControl>
    </app-dplist>
  </div> -->

  <!--select dropdown-->
  <!-- <div class="container my-select-box">
    <app-dplist [collection]="educations" [formControl]="formGroup.controls['education']" ngDefaultControl>
    </app-dplist>
  </div> -->

  <!-- <div class="container my-select-box" style="max-width: 300px;">
    <app-mat-autocomplete [data]="state" formControlName="inWhichCity" placeholder="{{'PROPERTY_DETAILS.Q1.PH1'|translate}}"></app-mat-autocomplete>
  </div> -->

  <!--select dropdown-->
  <!-- <div class="container my-select-box" style="max-width: 300px;">
    <app-dplist-new [valueArr]='maritalStatusNew' formControlName="maritalStatusNew" [atrrAriaLabel]="'top'"></app-dplist-new>
  </div> -->

  <!--select dropdown-->
  <!-- <div class="container my-select-box" style="max-width: 300px;">
    <app-dplist-new [aData]='educationNewObs' [asyncData]="true" [disabled]="true" formControlName="educationNew" [atrrAriaLabel]="'bottom'"></app-dplist-new>
  </div> -->

  <!-- <div class="container my-select-box" style="max-width: 300px;">
    <app-date-picker formControlName="birthDate" minDate="minBirthDate" maxDate="maxBirthDate" firstDayOfWeek=7 placeholder="dd/mm/yyyy" attAriaLabel="{{'USER_DETAILS.Q3.BIRTH_DATE'|translate}}" #birthDate></app-date-picker>
  </div> -->

<!-- </form> -->


// WEBPACK FOOTER //
// ./src/app/playground/playground.component.html